<script lang="ts">
    import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';

    interface Props {
        title: ProductTitle;
        brandOnTop?: boolean;
    }

    const { title, brandOnTop = false }: Props = $props();
</script>

<p class={['reptile-product-short-title__title', 'oc-copy-100', 'oc-text-color-default']}>
    <span class="reptile-product-short-title__brand">
        {title.brand}
    </span>
    {#if brandOnTop}
        <span class="reptile-product-short-title__title">{title.display}</span>
    {:else}
        {title.display}
    {/if}
</p>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-short-title {
        &__title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline;
            margin: 0;
            @include mixins.line-clamp(2);
        }
        &__brand {
            text-transform: uppercase;
        }
    }
</style>
